import Layout from './components/layout';
import Details from './components/Details';

export default {
	Layout,
	Details
}